import { render, staticRenderFns } from "./form-group-template.vue?vue&type=template&id=bd273faa&"
import script from "./form-group-template.vue?vue&type=script&lang=ts&"
export * from "./form-group-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports